import { useQuery } from "@tanstack/react-query";
import { callFunction } from "../lib/api";
import { mapMatch, MatchRow } from "../lib/match";
import { Match } from "../types";

const fetchMatch = async (id: string): Promise<Match> => {
  const data = (await callFunction(`/get-match?id=${id}`)) as MatchRow;
  return mapMatch(data);
};

export const useGetMatch = (matchId: string | undefined) => {
  return useQuery({
    queryKey: ["match", matchId],
    queryFn: () => {
      if (!matchId) {
        throw new Error("Match ID is required");
      }
      return fetchMatch(matchId);
    },
    enabled: !!matchId,
  });
};
